import { AxiosResponse } from 'axios';
import { get } from 'lodash';

export default function responseParser(response: AxiosResponse<any>) {
  return response.data.result || get(response, 'data.data.items') || response.data.data || response.data;
}
